// Country data based on the CSV file
export const SUPPORTED_COUNTRIES = [
  { code: 'US', name: 'United States', dialingCode: '+1' },
  { code: 'CA', name: 'Canada', dialingCode: '+1' },
  { code: 'GB', name: 'United Kingdom', dialingCode: '+44' },
  { code: 'AR', name: 'Argentina', dialingCode: '+54' },
  { code: 'AU', name: 'Australia', dialingCode: '+61' },
  { code: 'AT', name: 'Austria', dialingCode: '+43' },
  { code: 'BS', name: 'Bahamas', dialingCode: '+1-242' },
  { code: 'BH', name: 'Bahrain', dialingCode: '+973' },
  { code: 'BE', name: 'Belgium', dialingCode: '+32' },
  { code: 'BW', name: 'Botswana', dialingCode: '+267' },
  { code: 'BR', name: 'Brazil', dialingCode: '+55' },
  { code: 'BN', name: 'Brunei Darussalam', dialingCode: '+673' },
  { code: 'CL', name: 'Chile', dialingCode: '+56' },
  { code: 'CN', name: 'China', dialingCode: '+86' },
  { code: 'CO', name: 'Colombia', dialingCode: '+57' },
  { code: 'CR', name: 'Costa Rica', dialingCode: '+506' },
  { code: 'HR', name: 'Croatia', dialingCode: '+385' },
  { code: 'CU', name: 'Cuba', dialingCode: '+53' },
  { code: 'CY', name: 'Cyprus', dialingCode: '+357' },
  { code: 'CZ', name: 'Czechia', dialingCode: '+420' },
  { code: 'DK', name: 'Denmark', dialingCode: '+45' },
  { code: 'DO', name: 'Dominican Republic', dialingCode: '+1-809' },
  { code: 'EE', name: 'Estonia', dialingCode: '+372' },
  { code: 'FO', name: 'Faroe Islands', dialingCode: '+298' },
  { code: 'FI', name: 'Finland', dialingCode: '+358' },
  { code: 'FR', name: 'France', dialingCode: '+33' },
  { code: 'DE', name: 'Germany', dialingCode: '+49' },
  { code: 'GR', name: 'Greece', dialingCode: '+30' },
  { code: 'GL', name: 'Greenland', dialingCode: '+299' },
  { code: 'GU', name: 'Guam', dialingCode: '+1-671' },
  { code: 'HK', name: 'Hong Kong', dialingCode: '+852' },
  { code: 'HU', name: 'Hungary', dialingCode: '+36' },
  { code: 'IS', name: 'Iceland', dialingCode: '+354' },
  { code: 'IN', name: 'India', dialingCode: '+91' },
  { code: 'IE', name: 'Ireland', dialingCode: '+353' },
  { code: 'IT', name: 'Italy', dialingCode: '+39' },
  { code: 'JP', name: 'Japan', dialingCode: '+81' },
  { code: 'KR', name: 'Korea, Republic of', dialingCode: '+82' },
  { code: 'LV', name: 'Latvia', dialingCode: '+371' },
  { code: 'LI', name: 'Liechtenstein', dialingCode: '+423' },
  { code: 'LT', name: 'Lithuania', dialingCode: '+370' },
  { code: 'LU', name: 'Luxembourg', dialingCode: '+352' },
  { code: 'MO', name: 'Macao', dialingCode: '+853' },
  { code: 'MT', name: 'Malta', dialingCode: '+356' },
  { code: 'FM', name: 'Micronesia', dialingCode: '+691' },
  { code: 'MD', name: 'Moldova', dialingCode: '+373' },
  { code: 'NA', name: 'Namibia', dialingCode: '+264' },
  { code: 'NL', name: 'Netherlands', dialingCode: '+31' },
  { code: 'NZ', name: 'New Zealand', dialingCode: '+64' },
  { code: 'NF', name: 'Norfolk Island', dialingCode: '+672' },
  { code: 'MK', name: 'North Macedonia', dialingCode: '+389' },
  { code: 'NO', name: 'Norway', dialingCode: '+47' },
  { code: 'PW', name: 'Palau', dialingCode: '+680' },
  { code: 'PY', name: 'Paraguay', dialingCode: '+595' },
  { code: 'PL', name: 'Poland', dialingCode: '+48' },
  { code: 'PT', name: 'Portugal', dialingCode: '+351' },
  { code: 'PR', name: 'Puerto Rico', dialingCode: '+1-787' },
  { code: 'RO', name: 'Romania', dialingCode: '+40' },
  { code: 'SH', name: 'Saint Helena', dialingCode: '+290' },
  { code: 'SG', name: 'Singapore', dialingCode: '+65' },
  { code: 'SK', name: 'Slovakia', dialingCode: '+421' },
  { code: 'SB', name: 'Solomon Islands', dialingCode: '+677' },
  { code: 'ZA', name: 'South Africa', dialingCode: '+27' },
  { code: 'ES', name: 'Spain', dialingCode: '+34' },
  { code: 'SE', name: 'Sweden', dialingCode: '+46' },
  { code: 'CH', name: 'Switzerland', dialingCode: '+41' },
  { code: 'TW', name: 'Taiwan', dialingCode: '+886' },
  { code: 'TH', name: 'Thailand', dialingCode: '+66' },
  { code: 'TR', name: 'Turkey', dialingCode: '+90' },
  { code: 'UY', name: 'Uruguay', dialingCode: '+598' },
  { code: 'VI', name: 'Virgin Islands, U.S.', dialingCode: '+1-340' }
];

// Get country by dialing code
export const getCountryByDialingCode = (dialingCode) => {
  return SUPPORTED_COUNTRIES.find(country => 
    country.dialingCode === dialingCode || 
    country.dialingCode.startsWith(dialingCode)
  );
};

// Get country by country code
export const getCountryByCode = (countryCode) => {
  return SUPPORTED_COUNTRIES.find(country => country.code === countryCode);
};

// Detect country from phone number
export const detectCountryFromPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || !phoneNumber.startsWith('+')) {
    return null;
  }

  // Try to match the longest possible dialing code first
  for (let i = 5; i >= 2; i--) {
    const potentialCode = phoneNumber.substring(0, i);
    const country = getCountryByDialingCode(potentialCode);
    if (country) {
      return country;
    }
  }

  return null;
};

// Format phone number with country code
export const formatPhoneNumberWithCountry = (phoneNumber, countryCode) => {
  if (!phoneNumber || !countryCode) return phoneNumber;
  
  const country = getCountryByCode(countryCode);
  if (!country) return phoneNumber;

  // Remove all non-digit characters
  const digits = phoneNumber.replace(/\D/g, '');
  
  // If number already has the country code, return as is
  if (phoneNumber.startsWith(country.dialingCode)) {
    return phoneNumber;
  }

  // Add the country code
  return `${country.dialingCode}${digits}`;
};

// International phone number formatter that doesn't force +1
export const formatInternationalPhoneNumber = (phoneNumber, selectedCountry = null) => {
  if (!phoneNumber) return '';
  
  // If a specific country is selected, use that
  if (selectedCountry) {
    return formatPhoneNumberWithCountry(phoneNumber, selectedCountry);
  }
  
  // If the number already starts with +, return as is
  if (phoneNumber.startsWith('+')) {
    return phoneNumber;
  }
  
  // Remove all non-digit characters
  const digits = phoneNumber.replace(/\D/g, '');
  
  // If it's incomplete, return as is
  if (digits.length < 7) {
    return phoneNumber;
  }
  
  // Default to just adding + without forcing any country code
  return `+${digits}`;
}; 